import "../../assets/scss/base/pages/account/Voucher.scss";

// Components
import ShowMoreLessText from "../micro/ShowMoreLessText/ShowMoreLessText";
import ProductPlaceHolder from "../../assets/images/placeholder/ProductPlaceHolder.svg";

const imageCDN = process.env.REACT_APP_PINEAPPLE_IMAGE_CDN;

const AppliedVoucherCard = ({ voucher, discountAmount = 0, onRemove }) => {
    const normalizedVoucher =
        voucher?.Voucher || voucher?.voucher || voucher;

    const getRibbonText = () => {
        if (normalizedVoucher?.type === "Flat") {
            return `RM ${normalizedVoucher?.typeValue} OFF`;
        }
        if (normalizedVoucher?.type === "Percentage") {
            return `${normalizedVoucher?.typeValue}% OFF`;
        }
        return "APPLIED";
    };

    // Get seller/vendor display
    const getSellerDisplay = () => {
        if (normalizedVoucher.forAllVendors) {
            return "Pineapple.my";
        }

        if (Array.isArray(normalizedVoucher.vendors) && normalizedVoucher.vendors.length > 0) {
            return normalizedVoucher.vendors
                .map(vendor => vendor.companyName)
                .join(", ");
        }

        return "N/A";
    };

    const brands = Array.isArray(normalizedVoucher.brands)
        ? normalizedVoucher.brands
        : [];

    const getBrandImage = (brand) => {
        const path = brand?.logo || brand?.file;
        return path ? `${imageCDN}/${path}` : ProductPlaceHolder;
    };

    const getRemainingBrandNames = (visibleCount) =>
        brands
            .slice(visibleCount)
            .map((brand) => brand?.name)
            .filter(Boolean)
            .join(", ");

    const handleBrandImageError = (event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = ProductPlaceHolder;
    };

    return (
        <div className="voucher-card-ui applied-voucher-ui">
            {/* LEFT RIBBON */}
            <div className="voucher-ribbon">
                <span>{getRibbonText()}</span>
            </div>

            {/* RIGHT CONTENT */}
            <div className="voucher-content">
                {brands.length > 0 && (
                    <div className="voucher-brands">
                        <div className="voucher-brands-row">
                            {brands.slice(0, 2).map((brand) => (
                                <div
                                    key={brand.id}
                                    className="voucher-brand-logo"
                                    title={brand.name}
                                >
                                    <img
                                        src={getBrandImage(brand)}
                                        alt={brand.name || "Brand"}
                                        onError={handleBrandImageError}
                                    />
                                </div>
                            ))}
                            {brands.length > 2 && (
                                <div
                                    className="voucher-brand-more"
                                    title={getRemainingBrandNames(2)}
                                >
                                    +{brands.length - 2}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div className="voucher-header-ui applied-header">
                    <h3 className="voucher-title-ui" >
                        {normalizedVoucher?.code?.length > 27
                            ? normalizedVoucher.code.slice(0, 27) + "..."
                            : normalizedVoucher?.code}
                    </h3>

                    <span className="voucher-applied-status">Applied</span>
                </div>

                <p className="voucher-save-ui">
                    Save RM {Number(discountAmount).toFixed(2)} on this order!
                </p>

                <div className="voucher-divider" />

                <p className="voucher-seller-ui">
                    Seller : <span>{getSellerDisplay()}</span>
                </p>

                <div className="voucher__item__details__block">
                    <ShowMoreLessText
                        text={normalizedVoucher?.description}
                        maxLength={100}
                    />
                </div>

                <div className="applied-voucher-footer">
                    <span>  </span>
                    <span
                        className="applied-voucher-remove"
                        onClick={() => onRemove?.(normalizedVoucher)}
                    >
                        Remove
                    </span>
                </div>
            </div>
        </div>
    );
};

export default AppliedVoucherCard;
